/**
 * Australian Business Number validation.
 *
 * Source: Australian Business Register, "ABN format" (https://abr.business.gov.au/Help/AbnFormat),
 * checked 2026-10-21 (financial year 2026-27). Modulus 89 check: subtract 1 from the leftmost
 * digit, weight the 11 digits 10,1,3,5,7,9,11,13,15,17,19, the sum must be divisible by 89.
 */
const WEIGHTS = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19] as const

/** Strips spaces; the ABN is written `51 824 753 556` or `51824753556`. */
export function normaliseAbn(text: string): string {
  return text.replace(/\s+/g, "")
}

export function isValidAbn(text: string): boolean {
  const digits = normaliseAbn(text)
  if (!/^\d{11}$/.test(digits)) return false
  let sum = 0
  for (let i = 0; i < 11; i++) {
    const digit = Number(digits[i]) - (i === 0 ? 1 : 0)
    sum += digit * WEIGHTS[i]!
  }
  return sum % 89 === 0
}
